<pg-expandable-card
  #expandCard
  [originElement]="this.originElement"
  [bottomOffset]="this.bottomOffset"
  (expandChange)="this.handleExpandChange($event)"
  (backdropClick)="handleBackdropClick()"
  (cardClick)="handleCardClick()"
>
  <ng-container visibleContent>
    <!-- left column logic -->
    <div class="left-col">
      <ng-content select="[leftCol]"></ng-content>
    </div>
    <!-- center column logic -->
    <div class="content-col center-col flex-spacer">
      <div *ngIf="expandCard.expanded; else collapsedTpl">
        <ng-content select="[expandedCenterCol]"></ng-content>
      </div>
      <ng-template #collapsedTpl>
        <ng-content select="[previewCenterCol]"></ng-content>
      </ng-template>
      <ng-content select="[centerCol]"></ng-content>
    </div>
    <!-- right column logic -->
    <div class="right-col">
      <ng-container *ngIf="!expandCard.expanded">
        <ng-content select="[rightCol]"></ng-content>
      </ng-container>
    </div>
  </ng-container>
  <div class="expanded-form-content">
    <ng-content></ng-content>
  </div>
</pg-expandable-card>
